(function () {
    "use strict";

    angular.module('iMatApp')
        .factory("materialsService", materialsService);

    materialsService.$inject = ["$http", "_", "guard"];

    function materialsService($http, _, guard) {
        var baseUrl = "/3dprint/materials";

        return {
            getMaterials: getMaterials
        };

        function getMaterialsData(productTemplateId, useCache, canceler) {
            var request = {
                params: { productTemplateId: productTemplateId },
                canceler: canceler,
                cache: _.isBoolean(useCache) ? useCache : true // by default cache is used
            };

            return $http.get(baseUrl, request)
                .then(function (response) {
                    return response.data;
                });
        }

        function getMaterials(productTemplateId, canceler) {
            return getMaterialsData(productTemplateId, canceler)
                .then(function (materials) {
                    materials = prepareMaterialsToShow(materials);

                    return materials;
                });
        }

        function prepareMaterialsToShow(materials) {
            materials = sort(materials);
            extend(materials);

            return materials;
        }

        function sort(materials) {
            materials = _.sortBy(materials, function (i) {
                return i.orderRank;
            });

            _.each(materials, function (material) {
                material.colours = _.sortBy(material.colours, function (i) {
                    return i.orderRank;
                });
            });

            return materials;
        }

        function extend(materials) {

            walkByMaterials(materials, function (material) {
                material.imageClass = material.shortName.toLowerCase();
            });

            walkByColours(materials, function (material, colour) {
                var materialName = material.shortName;
                if (material.isExpress) {
                    materialName = materialName.toLowerCase().replace('-priority', '');
                }

                colour.imageClass = materialName + "_" + colour.shortName;
                colour.imageClass = colour.imageClass.toLowerCase();
            });
        }


        function walkByMaterials(materials, iteratee) {
            guard.argumentIsFunction(iteratee, 'iteratee');

            _.each(materials, function (material) {
                iteratee(material);
            });
        }

        function walkByColours(materials, iteratee) {
            guard.argumentIsFunction(iteratee, 'iteratee');

            walkByMaterials(materials, function (material) {
                _.each(material.colours, function (colour) {
                    iteratee(material, colour);
                });
            });
        }
    }
}());